import { createTheme } from '@mui/material/styles';
import '../styles/global.scss';

const theme = createTheme({
  palette: {
    primary: {
      main: '#056A0C', // Verde agricolo
      light: '#078F10',
      dark: '#044A08',
    },
    secondary: {
      main: '#056A0C', // Verde secondario
    },
    background: {
      default: '#FFFFFF',
      paper: '#F5F5F5',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: 'Montserrat, sans-serif',
  },
});

export default theme;